export const formFieldsForLiabilityType = () => {
  const sharedFields = [
    'name',
    'value',
    'monthly_repayment',
    'interest_rate',
    'term_of_debt'
  ]

  return [...sharedFields]
}
